export const MESSAGE_STATUS = {
  FAILED: 'failed',
  SENT: 'sent',
  PROGRESS: 'progress',
};

export const WA_MESSAGE_STATUS = {
  DELIVERED: 'delivered',
  SENT: 'sent',
  READ: 'read',
};

export const MESSAGE_TYPE = {
  INCOMING: 0,
  OUTGOING: 1,
  ACTIVITY: 2,
  TEMPLATE: 3,
  COMMENT: 9,
};
// Size in mega bytes
export const MAXIMUM_FILE_UPLOAD_SIZE = 40;
